import { NzButtonType } from 'ng-zorro-antd/button';
import { TicketSectionDto, DynamicFormDto, DynamicFormElementDto, TicketDetailDto, TicketDto, TicketElementDto, TicketStepDto, TicketButtonDto, DynamicPayloadDto_PropertyValueSimple, ButtonTypeEnum, TicketUploadPayload, TicketModeEnum } from '../../../service/dto';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpWorkflowService } from '../../../service/http-workflow.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpTicketService } from '../../../service/http-ticket.service';
import { Subscription } from 'rxjs';
import { FormControl, FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ComposeNotificationComponent, NotificationDto } from '../../../components/compose-notification/compose-notification.component';
import { FormControlWrapper } from '../../../components/dynamic-form/dynamic-form-abstract';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { InvalidFormDrawerComponent } from '../../workflow/workflow-form/components/invalid-form-drawer/invalid-form-drawer.component';
import { TicketCommunicationModalComponent } from './components/ticket-communication-modal/ticket-communication-modal.component';
import { TicketAdditionalCommentComponent } from './components/ticket-additional-comment/ticket-additional-comment.component';
import { TicketHistoryComponent } from './components/ticket-history/ticket-history.component';
import { HttpMemberService } from '../../../service/http-member.service';
import { TicketDuplicateWarningModalComponent } from './components/ticket-duplicate-warning-modal/ticket-duplicate-warning-modal.component';

@Component({
	selector: 'app-ticket-form',
	standalone: false,
	templateUrl: './ticket-form.component.html',
	styleUrl: './ticket-form.component.scss'
})
export class TicketFormComponent implements OnInit, OnDestroy {
	ticketMode!: TicketModeEnum;
	ticket?: TicketDto;
	dynamicForms?: { [key: number]: DynamicFormDto };
	masterForm!: FormGroup;
	allForms: FormGroup[] = [];
	allFormControls: FormControlWrapper[] = [];
	additionalFilesForm!: FormGroup;
	subscription = new Subscription();
	selectedStepIndex = 0;
	categories!: string;

	constructor(
		private fb: FormBuilder,
		private ticketService: HttpTicketService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private modalService: NzModalService,
		private drawerService: NzDrawerService) {
	}

	ngOnInit() {
		this.subscription.add(this.activatedRoute.paramMap.subscribe(params => {
			this.ticketMode = params.get('ticketMode')! as TicketModeEnum;
			const ticketId = params.get('ticketId');
			const workflowId = params.get('workflowId');
			const memberId = params.get('memberId');
			const dependentId = params.get('dependentId');
			this.categories = params.get('categories') == null ? '' : params.get('categories')!;
			this.masterForm = this.fb.group({});

			if (ticketId) {
				this.ticketService.get(+ticketId).subscribe(result => this.setTicket(result));
			} else if (memberId) {
				this.ticketService.newTicketForMainMember(+workflowId!, +memberId!).subscribe(result => this.setTicket(result));
			} else {
				this.ticketService.newTicketForDependant(+workflowId!, +dependentId!).subscribe(result => this.setTicket(result));
			}
		}));
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
	setTicket(input: TicketDto) {
		this.ticket = input;
		const activeStep = this.ticket.steps.filter(item => item.isCurrentState)[0];
		this.selectedStepIndex = this.ticket.steps.indexOf(activeStep);
		this.dynamicForms = {};
		this.masterForm = this.fb.group({});
		this.allForms = [];
		this.allFormControls = [];

		input.steps = input.steps.sort((i1, i2) => i1.order - i2.order);
		input.steps.forEach(step => {
			step.sections = step.sections.sort((i1, i2) => i1.order - i2.order);
			step.sections.forEach(section => {
				section.elements = section.elements.sort((i1, i2) => i1.order - i2.order);
			});
		});


		input.steps.forEach(step => {
			step.sections = step.sections.sort((i1, i2) => i1.order - i2.order);

			step.sections.forEach(section => {
				this.dynamicForms![section.id] = this.convertToDynamicForm(section);
			});
		});
		this.additionalFilesForm = this.fb.group([]);
		activeStep.additionalFiles.forEach(item => this.additionalFilesForm.addControl(item.label, new FormControl(item.uuid, [Validators.required])));
	}
	get step(): TicketStepDto {
		return this.ticket!.steps[this.selectedStepIndex]!;
	}

	getStepStatus(input: TicketStepDto): 'process' | 'wait' | 'finish' | 'error' {
		if (input.isCurrentState) {
			return 'process';
		}
		const current = this.ticket!.steps.filter(item => item.isCurrentState == true)[0];
		if (input.order >= current.order) {
			return 'wait';
		}
		if (input.completed) {
			return 'finish';
		}
		return 'wait';
	}
	getDetailGroups(input: TicketStepDto): { groupLabel: string, details: TicketDetailDto[] }[] {
		const groups: { [key: string]: TicketDetailDto[] } = {};
		for (const detail of input.details) {
			const label = detail.groupLabel || 'Ungrouped';
			if (!groups[label]) {
				groups[label] = [];
			}
			groups[label].push(detail);
		}
		return Object.entries(groups).map(([groupLabel, details]) => ({ groupLabel, details }));
	}
	setButtonBusy(button: TicketButtonDto, busy: boolean) {
		(button as any)['busy'] = busy;
	}
	isButtonBusy(button: TicketButtonDto): boolean {
		return (button as any)['busy'] ?? false;
	}
	buttonClick(button: TicketButtonDto) {
		const ticket = this.copyToTicket();
		const payload = this.getPostBody(ticket, button);

		if (!ticket.id) { //TODO:  OR button action verify unique == true
			this.ticketService.findDuplicateTickets(button, ticket, payload, this.categories).subscribe(result => {
				if (result.length == 0) {
					this.buttonClickStep2(button, ticket, payload);
				} else {
					const modal = this.modalService.create({
						nzTitle: 'Duplicate ' + ticket.ticketMode! + ' Detected',
						nzContent: TicketDuplicateWarningModalComponent,
						nzClosable: true,
						nzMaskClosable: false,
						nzWidth: 600,
						nzFooter: null
					});
					modal.componentInstance!.tickets = result;
					modal.afterClose.subscribe(result => {
						if (result == true) {
							this.buttonClickStep2(button, ticket, payload);
						}
					});
				}
			});
		} else {
			this.buttonClickStep2(button, ticket, payload);
		}
	}
	private buttonClickStep2(button: TicketButtonDto, ticket: TicketDto, payload: TicketUploadPayload) {
		if (button.onClickCaptureAdditionalComment) {
			const modal = this.modalService.create({
				nzTitle: 'Additional Comment',
				nzContent: TicketAdditionalCommentComponent,
				nzFooter: null
			});
			modal.componentInstance!.button = button;
			modal.componentInstance!.payload = payload;
			modal.afterClose.subscribe(result => {
				if (result == true) {
					this.buttonClickConfirmed(button, ticket, payload);
				}
			});
		} else {
			this.buttonClickConfirmed(button, ticket, payload);
		}
	}
	private buttonClickConfirmed(button: TicketButtonDto, ticket: TicketDto, payload: TicketUploadPayload) {
		const workflowId = this.ticket!.workflowId;
		const stepId = this.step.id;
		if (button.requiredCommunications.length == 0 && button.onClickComposeAdditionalCommunication == false) {
			if (button.onClickSubmitForm == true || (payload.additionalComment && payload.additionalComment.trim().length > 0)) {
				this.ticketService.submit(button, ticket, payload, this.categories!).subscribe(result => {
					const currentStep = this.ticket!.steps.filter(item => item.isCurrentState == true)[0];
					const resultStep = result.steps.filter(item => item.isCurrentState == true)[0];

					if (!resultStep || currentStep.id != resultStep.id || currentStep.stateLabel != resultStep.stateLabel) {
						this.setTicket(result);
					}
					this.router.navigate(['/ticket', this.ticketMode, workflowId, stepId, 'list']);
				});
				return;
			}
			this.router.navigate(['/ticket', this.ticketMode, workflowId, stepId, 'list']);
			return;
		}
		const additionalFiles: { [key: string]: string } = {};
		Object.keys(this.additionalFilesForm.controls).forEach(key => {
			additionalFiles[key] = this.additionalFilesForm.get(key)?.value;
		});
		console.log("Additional Files", additionalFiles);

		const modal = this.modalService.create({
			nzTitle: 'Compose',
			nzWidth: '80%',
			nzContent: TicketCommunicationModalComponent,
			nzFooter: null
		});
		modal.componentInstance!.ticketMode = this.ticketMode;
		modal.componentInstance!.step = this.step;
		modal.componentInstance!.button = button;
		modal.componentInstance!.additionalFiles = additionalFiles;

		this.ticketService.submitForPlaceholderValues(button, ticket, payload, this.categories!).subscribe(result => {
			modal.componentInstance!.placeholderValues = result;
		});

		modal.afterClose.subscribe(result => {
			console.log("Close:", result)
			if (result) {
				payload.additionalCommunications = button.additionalCommunications!;
				payload.requiredCommunications = {};
				if (button.requiredCommunications) {
					button.requiredCommunications.forEach(item => {
						payload.requiredCommunications[item.id] = item;
					})
				}
				this.ticketService.submit(button, ticket, payload, this.categories!).subscribe(result => {
					const currentStep = this.ticket!.steps.filter(item => item.isCurrentState == true)[0];
					const resultStep = result.steps.filter(item => item.isCurrentState == true)[0];
					const workflowId = ticket.workflowId;
					const stepId = this.step.id;


					if (!resultStep || currentStep.id != resultStep.id || currentStep.stateLabel != resultStep.stateLabel) {
						this.setTicket(result);
					}
					this.setTicket(result);
					this.router.navigate(['/ticket', this.ticketMode, workflowId, stepId, 'list']);
				});
			} else {
				console.log('Modal cancelled');
			}
		});
	}

	private copyToTicket(): TicketDto {
		let out: TicketDto = JSON.parse(JSON.stringify(this.ticket));
		let step = out.steps.filter(item => item.isCurrentState == true)[0];
		step.sections.forEach(section => {
			const properties = this.allFormControls.map(item => item.toBackendPayload())
			section.elements.forEach(element => {
				const dfElement = properties.filter(item => item.propertyId == element.id)[0];
				element.value = (dfElement.value as DynamicPayloadDto_PropertyValueSimple).value;
			});
		});
		return out;
	}
	private getPostBody(input: TicketDto, button: TicketButtonDto): TicketUploadPayload {
		const out: TicketUploadPayload = {
			button: button,
			additionalFiles: {},
			fieldProperties: {},
			requiredCommunications: {},
			additionalCommunications: []
		};
		let step = input.steps.filter(item => item.isCurrentState == true)[0];
		step.sections.map(item => item.elements).flat().forEach(item => {
			out.fieldProperties[item.id] = item.value;
		})
		Object.keys(this.additionalFilesForm.controls).forEach(key => {
			out.additionalFiles[key] = this.additionalFilesForm.get(key)?.value;
		});
		button.requiredCommunications.forEach(item => {
			out.requiredCommunications[item.id] = JSON.parse(JSON.stringify(item));
		});
		out.additionalCommunications = JSON.parse(JSON.stringify(button.additionalCommunications ?? []));

		Object.keys(out.requiredCommunications).forEach(key => {
			const requiredCommunication = out.requiredCommunications[+key];
			requiredCommunication.attachments = requiredCommunication.attachments?.filter(item => item.selected == true);
		})
		Object.keys(out.additionalCommunications).forEach(key => {
			const additionalCommunication = out.additionalCommunications[+key];
			additionalCommunication.attachments = additionalCommunication.attachments?.filter(item => item.selected == true);
		})
		return out;
	}




	getNzButtonType(input: TicketButtonDto): NzButtonType {
		if (input.requiredValidForm == false) {
			return input.type.toLowerCase() as NzButtonType;
		}
		if (this.masterForm.valid == true) {
			return input.type.toLowerCase() as NzButtonType;
		}
		return 'default';
	}
	highlightInvalidFields() {
		const ref = this.drawerService.create({
			nzTitle: 'Errors',
			nzContent: InvalidFormDrawerComponent,
			nzWidth: 'large',
			nzContentParams: { form: this.masterForm }
		});
		ref.open();
	}



	private convertToDynamicForm(input: TicketSectionDto): DynamicFormDto {
		const elements = input.elements.map(item => {
			return {
				id: item.id,
				value: item.value,
				property: '_' + item.id,
				dependencyId: item.dependencyId,

				name: item.label,
				description: item.description,
				sectionName: input.label,
				dependencyValue: item.dependencyValue,
				dataType: item.dataType,
				options: item.options,
				orderIndex: item.order,
				icon: item.icon,
				activeOnCreate: true,
				activeOnUpdate: true,
				required: item.required,
				errorMessageRequired: item.errorMessageRequired,
				isUnique: item.isUnique,
				errorMessageUnique: item.errorMessageUnique,
				regex: item.regex,
				errorMessageRegex: item.errorMessageRegex,
				minValue: item.minValue,
				errorMessageMinValue: item.errorMessageMinValue,
				maxValue: item.maxValue,
				errorMessageMaxValue: item.errorMessageMaxValue,
				hashCode: 0
			};
		});

		return {
			id: undefined,
			templateName: 'card',
			elements: elements,
			entityType: 'Member',
			subForms: {},
			hashCode: 0
		};
	}
	showTicketHistory(ticket: TicketDto, title: string) {
		const modal = this.modalService.create({
			nzTitle: title,
			nzContent: TicketHistoryComponent,
			nzWidth: '80%',
			nzFooter: null
		});
		modal.componentInstance!.ticket = ticket!;
	}
}
